define('responsive-gameday/views/render/PitchFXViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/pitchFX/pitchFX'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function PitchFXViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/pitchFX/pitchFX'),{
            }
        );
    }
    ViewRender.spawn(PitchFXViewRender);

    Superclass=PitchFXViewRender.superclass;

    return PitchFXViewRender;
});
